export default "__VITE_ASSET__Coavj$aC__"